import TalentDetail from "@/features/talent/pages/TalentDetail";

const TalentDetailPage = () => {
  return <TalentDetail />;
};

export default TalentDetailPage;
